module.exports = __webpack_public_path__ + "assets/img/home_foot_logo.c1618320.png";